import { emailValidation } from "../../utils/GeneralUtils";

const validate = (values: any,props:any) => {

    const errors: {
      businessName: any;
      productName: any;
      businessZipCode: any;
      businessPhoneNumber: any;
      businessEmail: any;
      contactZipCode: any;
      locationName: any;
      name: any;
      url: any;
      streetAddress:string | undefined;
      unitSuite:string|undefined;
      city:string|undefined;
      state:string|undefined;
      emailContact: string | undefined;
      firstName: string | undefined;
      lastName: string | undefined;
      title: string | undefined;
      email: string | undefined;
      roles: string | undefined;
      newPassword: string | undefined;
      confirmNewPassword: string | undefined;
      phone: string | undefined;
      time: string | undefined;
      dob: string | undefined;
      recipient: any;
      subject: string | undefined;
      message: string | undefined;
      expectedClose: string | undefined;
      account: string | undefined;
      contactFirstName: string|undefined;
      phoneType: string|undefined;
      emailType: string|undefined;
      phoneNumber:string|undefined;
      zipCode: string|undefined;
      phoneExt:string|undefined;
      
    } = {
      businessName: undefined,
      account: undefined,
      businessEmail: undefined,
      businessPhoneNumber: undefined,
      title: undefined,
      streetAddress:undefined,
      unitSuite:undefined,
      city:undefined,
      state:undefined,
      locationName: undefined,
      name: undefined,
      url: undefined,
      emailContact: undefined,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      roles: undefined,
      productName: undefined,
      newPassword: undefined,
      confirmNewPassword: undefined,
      phone: undefined,
      time: undefined,
      dob: undefined,
      recipient: undefined,
      subject: undefined,
      message: undefined,
      businessZipCode: undefined,
      contactZipCode: undefined,
      expectedClose: undefined,
      contactFirstName: undefined,
      phoneType:undefined,
      emailType:undefined,
      phoneNumber:undefined,
      zipCode:undefined,
      phoneExt:undefined,
    };
       
      if ((!values?.firstName) || (!values?.firstName && values?.isPrimary)) {
        errors.firstName = "Required";
      }
      if (!values?.lastName && values?.isPrimary) {
        errors.lastName = "Required";
      }
      if(!values?.title && values?.isPrimary){
        errors.title="Required";
      }
      if(!values?.streetAddress && values?.isPrimary){
        errors.streetAddress ="Required"
      }
      if(!values?.city && values?.isPrimary){
        errors.city ="Required"
      }
      if(!values?.state && values?.isPrimary){
        errors.state ="Required"
      }
      if(!values?.zipCode && values?.isPrimary){
        errors.zipCode ="Required"
      }
      if(!values?.email && values?.isPrimary){
        errors.email ="Required"
      }
      if(!values?.emailType && values?.isPrimary){
        errors.emailType ="Required"
      }
      if(!values?.phoneNumber && values?.isPrimary){
        errors.phoneNumber ="Required"
      }
      if(!values?.phoneExt && values?.isPrimary){
        errors.phoneExt = "Required"
      }
      if(!values?.phoneType && values?.isPrimary){
        errors.phoneType ="Required"
      }
        
      if (values?.phoneType) {
        if ((values.phone && values.phone.length < 11)  && values.phoneNumber.length >3) {
          errors.phone = "Required";
        }
      } 
      
        if (
          values?.email &&
          !emailValidation().test(values.email)
        ) {
          errors.email = "*Please enter your email in format: yourname@example.com";
        }
        if (values?.email) {
           if (!values.emailType) {
            errors.emailType = "Required";
          }
        }
        if (values?.emailType) {
          if (!values.email) {
            errors.email = "Required";
          }
        }
      
        if (values?.phoneNumber) {
          if (values.phoneNumber.length < 11) {
            errors.phoneNumber = "Enter 10 digits";
          }
         
          if (!values.phoneType) {
            errors.phoneType = "Required";
          }
        }
        if (values?.phoneType) {
          if (!values.phoneNumber||values.phoneNumber.length<3) {
            errors.phoneNumber = "Required";
          }
        }
      if (
        values?.zipCode === "0" ||
        values?.zipCode === "00" ||
        values?.zipCode === "000" ||
        values?.zipCode === "0000" ||
        values?.zipCode === "00000"
      ) {
        errors.zipCode = "Invalid zip";
      }
      if (
        values?.zipCode?.length < 5 &&
        values?.zipCode?.length !== 0
      ) {
        errors.zipCode = "Atleast 5 digits required";
      }
      return errors;  
  };
  
  export default validate;
  